import { createContext } from 'react'

/**
 * The element at the end of the shell's `<main>`, after the routed page (R73).
 * `null` outside the shell (a unit test, the specimen): `PageEnd` then renders
 * in place.
 */
export const PageEndContext = createContext<HTMLElement | null>(null)
